module.exports = __webpack_public_path__ + "img/et.8edd7319.svg";